export default __webpack_public_path__ + "../images/apple-touch-icon-60x60.png";